import { motion } from "framer-motion"
import styled, { keyframes } from "styled-components"

const owlSteps = keyframes`
  from { background-position-x: 0px; }
  to   { background-position-x: -128px; } /* 3 frames */
`

const OwlSprite = styled(motion.div)`
  width: 44px;
  height: 64px;
  background-repeat: no-repeat;
  background-size: 128px 64px;
  animation: ${owlSteps} 0.3s steps(3) infinite;
`

export function OwlRunner({ loading }: { loading: boolean }) {
  const owlSprite = require("@/assets/owl_anims/owl-run-sprite.png")

  if (!loading) return null

  return <OwlSprite style={{ backgroundImage: `url(${owlSprite})` }} />
}
